import React from 'react';
interface CardProps {
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}
export const Card = ({
  children,
  onClick,
  active = false,
  className = ''
}: CardProps) => {
  return <div onClick={onClick} className={`
        p-4 rounded-xl shadow-sm 
        ${onClick ? 'cursor-pointer transition-all duration-200 hover:shadow-md' : ''}
        ${active ? 'border-2 border-blue-500 bg-blue-50' : 'border border-gray-200 bg-white'}
        ${className}
      `} data-id="element-1517">
      {children}
    </div>;
};